const MAX_RPC_ENDPOINTS = 8;

export const normalizeRpcEndpointPool = (value, maxEndpoints = MAX_RPC_ENDPOINTS) => {
  const source = Array.isArray(value)
    ? value
    : String(value || '').split(/[\r\n,]+/);
  const seen = new Set();
  const urls = [];

  source.forEach((entry) => {
    const url = String(entry || '').trim();
    if (!url || seen.has(url) || urls.length >= maxEndpoints) return;
    seen.add(url);
    urls.push(url);
  });

  return urls;
};

export const normalizeRpcIndexPool = (value, maxEndpoints = MAX_RPC_ENDPOINTS) => {
  const source = Array.isArray(value) ? value : [value];
  const seen = new Set();
  const indexes = [];

  source.forEach((entry) => {
    const index = Number(entry);
    if (!Number.isInteger(index) || index < 0 || seen.has(index) || indexes.length >= maxEndpoints) {
      return;
    }
    seen.add(index);
    indexes.push(index);
  });

  return indexes;
};

export const resizeRpcIndexPool = ({
  selectedIndexes,
  availableIndexes,
  targetSize,
  maxEndpoints = MAX_RPC_ENDPOINTS,
} = {}) => {
  const available = normalizeRpcIndexPool(availableIndexes, maxEndpoints);
  const allowed = new Set(available);
  const requestedSize = Number(targetSize);
  const size = Math.min(
    available.length,
    maxEndpoints,
    Number.isInteger(requestedSize) && requestedSize > 0 ? requestedSize : 1
  );
  const next = normalizeRpcIndexPool(selectedIndexes, maxEndpoints)
    .filter((index) => allowed.has(index))
    .slice(0, size);

  for (const index of available) {
    if (next.length >= size) break;
    if (!next.includes(index)) next.push(index);
  }

  return next;
};

export const mergeRpcPresetChoices = ({ maikoRpcs = [], chainRpcs = [] } = {}) => [
  ...maikoRpcs.filter((rpc) => !rpc?.catalogManaged),
  ...chainRpcs,
  ...maikoRpcs.filter((rpc) => rpc?.catalogManaged),
];

export const getRpcPoolConnectionType = (urls) => {
  const normalized = normalizeRpcEndpointPool(urls);
  const hasWebSocket = normalized.some((url) => /^wss?:\/\//i.test(url));
  const hasHttp = normalized.some((url) => /^https?:\/\//i.test(url));

  if (hasWebSocket && hasHttp) return 'mixed';
  if (hasWebSocket) return 'ws';
  return 'http';
};

export const getRpcPoolExtraUrls = ({
  selectedRpc,
  additionalRpcs,
  primaryRpcUrl,
  connectedEndpoints,
} = {}) => {
  const connectedUrls = Array.isArray(connectedEndpoints) && connectedEndpoints.length > 0
    ? connectedEndpoints
      .filter((endpoint) => endpoint?.connected !== false)
      .map((endpoint) => endpoint?.url)
    : (Array.isArray(selectedRpc?.urls) ? selectedRpc.urls : []);

  return normalizeRpcEndpointPool([
    ...connectedUrls,
    ...(Array.isArray(additionalRpcs) ? additionalRpcs : []),
  ]).filter((url) => url !== primaryRpcUrl);
};

export const MAX_RPC_POOL_SIZE = MAX_RPC_ENDPOINTS;
